import countBy from 'lodash.countby';
import remove from 'lodash.remove';
import uniqBy from 'lodash.uniqby';

import { ADD_PARTS, REMOVE_PART, CHANGE_PART_QUANTITY, RESET_ORDER } from '../actions/index';


// default states
// list of parts with quantities chosen by the user
// array of 'partOrders' = { part, quantity }
const orderState = [];

// reducers
function order(state = orderState, action) {
  switch (action.type) {
    case ADD_PARTS: {
      // If part is already in the order,
      // update the quantity, otherwise add it to the end of the list
      const partsCount = countBy(action.newParts, 'partNo');
      const newParts = uniqBy(action.newParts, 'partNo');
      const newState = state.map((partOrder) => {
        const partQuantity = partsCount[partOrder.part.partNo];
        if (typeof partQuantity !== 'undefined') {
          // need to remove the part from 'newParts' now so it won't be pushed to the end
          // of the list
          remove(newParts, part => part.partNo === partOrder.part.partNo);
          return {
            ...partOrder,
            quantity: partOrder.quantity + partQuantity
          };
        }
        return partOrder;
      });
      // now push the remaining newParts on the back of newState
      return [...newState, ...newParts.map(part => ({
        part,
        quantity: partsCount[part.partNo]
      }))];
    }
    case REMOVE_PART: {
      const idx = state.findIndex(partOrder => partOrder.part.partNo === action.partNo);
      if (idx >= 0) {
        return state.slice(0, idx).concat(state.slice(idx + 1));
      }
      return state;
    }
    case CHANGE_PART_QUANTITY:
      return state.map((partOrder) => {
        const { part } = partOrder;
        if (part.partNo === action.partNo) {
          return {
            part,
            quantity: action.quantity
          };
        }
        // otherwise keep same object
        return partOrder;
      });
    case RESET_ORDER:
      return [];
    default:
      return state;
  }
}

export default order;
